import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { UserDomainModel } from '../../domainModels/user-domain-model';
import { HydratedAdminUser } from '../../models/account/dto/hydrated-admin-user';
import { exists } from '../../functions/exists';

type Activation = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(
    private userDomainModel: UserDomainModel,
    public router: Router
  ) {}

  public findTerm(href: string, term: string): string {
    if (href.includes(term)) {
      return href;
    }
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Activation {
    return this.userDomainModel.user$
      .firstNotNull()
      .pipe(map(user => this.canAccess(state, user) || this.router.parseUrl('')));
  }

  canAccess(state: RouterStateSnapshot, user: HydratedAdminUser): boolean {
    const isPermitted = this.routeIsPermitted(state, user);
    if (!isPermitted) this.navigate(user, isPermitted);
    return isPermitted;
  }

  private routeIsPermitted(state: RouterStateSnapshot, user: HydratedAdminUser): boolean {
    if (exists(user)) {
      switch (state?.url) {
        // These routes are accessible for all users
        case this.findTerm(state?.url, '/auth'):
        case this.findTerm(state?.url, '/products'):
        case this.findTerm(state?.url, '/account'):
          return true;
        // Handle case so that all other routes are blocked if productOnlyAccess.
        default:
          return !user.productOnlyAccess;
      }
    }
    return true;
  }

  private navigate(user: HydratedAdminUser, isPermitted: boolean): void {
    user.productOnlyAccess
      ? this.router.navigate(['products/universalvariants']).then(() => {})
      : this.router.navigate(['']).then(() => {});
  }
}
